/**
 * EditProjectModal — edita os campos de um projeto (nome, descrição, prioridade,
 * status, prazo). Sem template (isso é só na criação). Grava via pjUpdateProject
 * e devolve o projeto atualizado em onSaved. Aberto pelo ProjectMenu (engrenagem)
 * na lista e no board.
 */

import { useState } from 'react'
import { pjUpdateProject } from '../../db/api.js'
import { PRIO_ORDER, PROJECT_STATUS, PROJECT_STATUS_LABEL } from './projetosKit.jsx'

const toDateInput = (v) => (v ? String(v).slice(0, 10) : '')

export default function EditProjectModal({ project, onClose, onSaved }) {
  const [nome, setNome] = useState(project.nome || '')
  const [descricao, setDescricao] = useState(project.descricao || '')
  const [prioridade, setPrioridade] = useState(project.prioridade || 'media')
  const [status, setStatus] = useState(project.status || 'ativo')
  const [prazo, setPrazo] = useState(toDateInput(project.prazo))
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState(null)

  const submit = async () => {
    if (!nome.trim() || saving) return
    setSaving(true); setErr(null)
    try {
      const updated = await pjUpdateProject(project.id, {
        nome: nome.trim(),
        descricao: descricao.trim() || null,
        prioridade, status,
        prazo: prazo || null,
      })
      onSaved?.(updated)
    } catch (e) { setErr(e.message); setSaving(false) }
  }

  return (
    <div style={S.overlay} onMouseDown={onClose}>
      <div style={S.box} onMouseDown={(e) => e.stopPropagation()}>
        <div style={S.head}>
          <h4 style={S.title}>Editar projeto</h4>
          <button style={S.x} onClick={onClose}>×</button>
        </div>
        {err && <div style={S.error}>{err}</div>}

        <label style={S.miniLabel}>Nome</label>
        <input style={S.input} value={nome} autoFocus onChange={(e) => setNome(e.target.value)} />

        <label style={S.miniLabel}>Descrição</label>
        <textarea style={S.textarea} value={descricao} placeholder="Descrição do projeto…"
          onChange={(e) => setDescricao(e.target.value)} />

        <div style={S.grid}>
          <div>
            <label style={S.miniLabel}>Prioridade</label>
            <select style={S.input} value={prioridade} onChange={(e) => setPrioridade(e.target.value)}>
              {PRIO_ORDER.map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <div>
            <label style={S.miniLabel}>Status</label>
            <select style={S.input} value={status} onChange={(e) => setStatus(e.target.value)}>
              {PROJECT_STATUS.map((s) => <option key={s} value={s}>{PROJECT_STATUS_LABEL[s] || s}</option>)}
            </select>
          </div>
          <div>
            <label style={S.miniLabel}>Prazo</label>
            <input style={S.input} type="date" value={prazo} onChange={(e) => setPrazo(e.target.value)} />
          </div>
        </div>

        <div style={S.footer}>
          <button style={S.btnGhost} onClick={onClose}>Cancelar</button>
          <button style={S.btnPrimary} onClick={submit} disabled={saving || !nome.trim()}>
            {saving ? 'Salvando…' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  )
}

const S = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(16,24,40,.35)', zIndex: 1300,
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
  },
  box: {
    width: 520, maxWidth: '100%', background: 'var(--surface)', border: '1px solid #eaecf0',
    borderRadius: 14, padding: 20, boxShadow: '0 24px 48px rgba(16,24,40,.24)',
    display: 'flex', flexDirection: 'column', gap: 10, maxHeight: '86vh', overflowY: 'auto',
  },
  head: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  title: { margin: 0, fontSize: 17, fontWeight: 700, color: '#101828' },
  x: { border: 'none', background: 'transparent', width: 28, height: 28, borderRadius: 8, cursor: 'pointer', color: '#667085', fontSize: 20, lineHeight: 1 },
  miniLabel: { display: 'block', fontSize: 13, fontWeight: 500, color: '#344054', marginBottom: 6, marginTop: 8 },
  input: {
    width: '100%', boxSizing: 'border-box', height: 38, padding: '0 12px', borderRadius: 8,
    border: '1px solid #d0d5dd', background: 'var(--surface)', color: '#101828', fontSize: 13, fontFamily: 'inherit',
  },
  textarea: {
    width: '100%', boxSizing: 'border-box', minHeight: 80, resize: 'vertical', padding: '10px 12px',
    borderRadius: 8, border: '1px solid #d0d5dd', background: 'var(--surface)', color: '#101828',
    fontSize: 13, lineHeight: 1.45, fontFamily: 'inherit',
  },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 14, paddingTop: 14, borderTop: '1px solid #eaecf0' },
  btnPrimary: {
    display: 'inline-flex', alignItems: 'center', gap: 8, height: 38, padding: '0 14px', borderRadius: 8,
    border: '1px solid var(--blue)', background: 'var(--blue)', color: '#fff',
    fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
  },
  btnGhost: {
    display: 'inline-flex', alignItems: 'center', gap: 8, height: 38, padding: '0 14px', borderRadius: 8,
    border: '1px solid #d0d5dd', background: 'var(--surface)', color: '#344054',
    fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit',
  },
  error: {
    padding: '10px 14px', borderRadius: 10, background: '#fef6f5',
    border: '1px solid #fbd9d3', color: '#b42318', fontSize: 13,
  },
}
